import BaseScene from "../../scenes/BaseScene";
import { PHShape } from "../../plugins/global/PlaceholderPlugin";

export default class TapOutComponent extends Phaser.GameObjects.Container {
  // a container is much like a html element, it has a parent (possible the scene or game world), and can have childen added via this.add
  private progressDisplay: Phaser.GameObjects.Image;
  private tapFace: Phaser.GameObjects.Image;
  private progressTimer: Phaser.Time.TimerEvent;
  private tapDisplayButton: Phaser.GameObjects.Image;
  private enemy: Phaser.GameObjects.Image;
  private shield: Phaser.GameObjects.Image;
  private rundownRate: number;
  private fullBoost: boolean;
  private maxReached: boolean;

  constructor(scene: BaseScene, x: number, y: number, decreaseRate: number) {
    // super to creat the container at the specified co-ordinates.
    super(scene, x, y);

    // !important - as we are using the 'new' keyword (and not using the scene
    // factory methods, `scene.add` ) we need to add it to the scene manually
    scene.add.existing(this);

    this.rundownRate = decreaseRate / 100;
    this.fullBoost = false;
    this.maxReached = false;

    this.progressDisplay = scene.sponge.placeholder
      .image(
        scene,
        0,
        -42,
        PHShape.RECT,
        { width: 116, height: 172, radius: 0 },
        0xffffff
      )
      .setOrigin(0.5, 1);
    this.add(this.progressDisplay);

    this.tapFace = this.scene.add.image(
      0,
      -140,
      "tap-out-atlas",
      "happyTap.png"
    );
    this.add(this.tapFace);

    this.enemy = this.scene.add
      .image(0, -42, "tap-out-atlas", "enemyTap.png")
      .setAlpha(0)
      .setOrigin(0.5, 1);
    this.add(this.enemy);
    this.shield = this.scene.add
      .image(0, -124, "tap-out-atlas", "tapShield.png")
      .setAlpha(0)
      .setScale(0.95);
    this.add(this.shield);

    const overlay = this.scene.add.graphics({ x: 0, y: 0 });
    this.add(overlay);

    overlay.moveTo(-67, -248);
    overlay.lineStyle(3, 0xffffff);
    // overlay.strokeRoundedRect(-67, -248, 134, 248, 20);
    overlay.strokeRect(-58, -214, 116, 170);
    overlay.strokeCircle(0, -22, 6);
    overlay.strokeRect(-12, -230, 24, 3);
    overlay.moveTo(-12, -230).lineTo(12, -230);

    this.tapDisplayButton = this.scene.add
      .image(0, 8, "tap-out-atlas", "phone.png")
      .setOrigin(0.5, 1)
      .setAlpha(0.7)
      .setTint(0xacdff4);
    this.add(this.tapDisplayButton);

    this.tapDisplayButton.on("pointerdown", this.topUpProgress, this);

    this.progressTimer = this.scene.time.addEvent({
      delay: 100,
      repeat: -1,
      callbackScope: this,
      callback: this.updateDisplay,
      paused: true,
    });

    // this.initProgress();
  }

  initProgress() {
    const rndStart = Phaser.Math.RND.between(60, 80) / 100;
    this.progressDisplay.setScale(1, rndStart);
    this.tapFace.setAlpha(1);
    this.shield.setAlpha(0);
    this.enemy.setAlpha(0);
    this.updateDisplay();
    this.maxReached = false;
    this.startRundown();
  }

  setRundownParameters(newRate: number, fullBoost: boolean) {
    this.rundownRate = newRate / 100;
    this.fullBoost = fullBoost;
  }

  startRundown() {
    //
    if(this.maxReached){return}
    this.progressTimer.paused = false;
    this.tapDisplayButton.setInteractive();
  }

  pauseRundown() {
    //
    this.progressTimer.paused = true;
    this.tapDisplayButton.disableInteractive();
  }

  topUpProgress() {
    //
    this.pauseRundown();

    const boost = this.fullBoost ? 1 : (this.progressDisplay.scaleY += 0.4);
    if (boost >= 1) {
      this.progressDisplay.setScale(1);
      this.updateDisplay();
      this.tapFace.setAlpha(0);
      this.shield.setAlpha(1);
      this.maxReached = true;
      this.emit("tapOutItemSecure");
    } else {
      this.progressDisplay.setScale(1, boost);
      this.updateDisplay();
      this.startRundown();
    }
  }

  updateDisplay() {
    this.progressDisplay.scaleY -= this.rundownRate;

    if (this.progressDisplay.scaleY > 0.65) {
      this.tapFace.setTexture("tap-out-atlas", "happyTap.png");
      this.progressDisplay.setTint(0x61d1c9);
    } else if (
      this.progressDisplay.scaleY > 0.3 &&
      this.progressDisplay.scaleY <= 0.65
    ) {
      this.tapFace.setTexture("tap-out-atlas", "medTap.png");
      this.progressDisplay.setTint(0xfc9164);
    } else if (
      this.progressDisplay.scaleY > 0 &&
      this.progressDisplay.scaleY <= 0.3
    ) {
      this.tapFace.setTexture("tap-out-atlas", "sadTap.png");
      this.progressDisplay.setTint(0xe23e65);
    } else {
      this.pauseRundown();
      this.tapDisplayButton.disableInteractive();
      this.enemy.setAlpha(1);
      this.emit("tapOutReachedBottom");
    }
  }

  update(): void {
    // const delta = this.scene.time.
  }
}
